module.exports = __webpack_public_path__ + "static/img/deviceItem.831993bd.png";